import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LocaleImportsService {
  private loadedLocales = new Set<string>();

  async loadLocale(locale: string): Promise<void> {
    if (!locale || this.loadedLocales.has(locale)) return;

    const normalized = locale.toLowerCase();

    try {
      switch (normalized) {
        case 'pt':
        case 'pt-pt': {
          const module = await import('@angular/common/locales/pt');
          registerLocaleData(module.default, 'pt-PT');
          this.loadedLocales.add('pt-PT');
          break;
        }

        case 'en':
        case 'en-us': {
          const module = await import('@angular/common/locales/en');
          registerLocaleData(module.default, 'en-US');
          this.loadedLocales.add('en-US');
          break;
        }

        case 'fr':
        case 'fr-fr': {
          const module = await import('@angular/common/locales/fr');
          registerLocaleData(module.default, 'fr-FR');
          this.loadedLocales.add('fr-FR');
          break;
        }

        case 'es':
        case 'es-es': {
          const module = await import('@angular/common/locales/es');
          registerLocaleData(module.default, 'es-ES');
          this.loadedLocales.add('es-ES');
          break;
        }

        case 'es-mx': {
          const module = await import('@angular/common/locales/es-MX');
          registerLocaleData(module.default, 'es-MX');
          this.loadedLocales.add('es-MX');
          break;
        }

        case 'es-ec': {
          const module = await import('@angular/common/locales/es-EC');
          registerLocaleData(module.default, 'es-EC');
          this.loadedLocales.add('es-EC');
          break;
        }

        case 'ro':
        case 'ro-ro': {
          const module = await import('@angular/common/locales/ro');
          registerLocaleData(module.default, 'ro-RO');
          this.loadedLocales.add('ro-RO');
          break;
        }

        case 'pl':
        case 'pl-pl': {
          const module = await import('@angular/common/locales/pl');
          registerLocaleData(module.default, 'pl-PL');
          this.loadedLocales.add('pl-PL');
          break;
        }

        default:
          console.warn(`L10n '${locale}' is not supported.`);
      }
    } catch (error) {
      console.error(`Falha ao carregar locale '${locale}':`, error);
    }
  }
}
